<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,24C5.383,24,0,18.617,0,12C0,5.383,5.383,0,12,0c6.617,0,12,5.383,12,12C24,18.617,18.617,24,12,24z M12,1.5
		C6.21,1.5,1.5,6.21,1.5,12c0,5.79,4.71,10.5,10.5,10.5c5.79,0,10.5-4.71,10.5-10.5C22.5,6.21,17.79,1.5,12,1.5z"/>
	<path d="M11.986,19.503c-1.159,0-2.276-0.262-3.319-0.779C7.205,18,6.001,16.795,5.276,15.333
		c-0.089-0.179-0.103-0.383-0.039-0.573c0.064-0.19,0.198-0.344,0.378-0.432c0.103-0.051,0.218-0.078,0.333-0.078
		c0.287,0,0.545,0.16,0.672,0.417c0.58,1.17,1.543,2.134,2.713,2.713c0.835,0.413,1.727,0.623,2.653,0.623c0,0,0,0,0,0
		c2.304,0,4.369-1.279,5.389-3.336c0.127-0.257,0.385-0.417,0.672-0.417c0.115,0,0.229,0.027,0.333,0.078
		c0.179,0.089,0.313,0.242,0.378,0.432c0.064,0.19,0.05,0.393-0.039,0.573C17.445,17.906,14.865,19.503,11.986,19.503z"/>
	<path d="M5.732,9.518c-0.118,0-0.236-0.029-0.342-0.083C5.212,9.344,5.08,9.189,5.018,8.998S4.973,8.604,5.065,8.426
		c0.751-1.467,2.305-2.415,3.958-2.415c0.294,0,0.589,0.03,0.877,0.088c0.405,0.082,0.668,0.479,0.586,0.884
		c-0.071,0.348-0.38,0.601-0.735,0.601c-0.049,0-0.098-0.005-0.148-0.015C9.41,7.53,9.215,7.51,9.02,7.51
		C7.926,7.51,6.897,8.138,6.4,9.11C6.271,9.362,6.015,9.518,5.732,9.518z"/>
	<path d="M18.268,9.518c-0.283,0-0.539-0.156-0.668-0.408c-0.498-0.972-1.526-1.599-2.621-1.599c-0.194,0-0.389,0.02-0.58,0.058
		c-0.051,0.01-0.1,0.015-0.148,0.015c-0.356,0-0.665-0.253-0.736-0.601c-0.04-0.196-0.001-0.396,0.11-0.563
		c0.111-0.167,0.28-0.281,0.476-0.321c0.288-0.058,0.583-0.088,0.877-0.088c1.653,0,3.207,0.948,3.958,2.415
		c0.091,0.178,0.108,0.381,0.046,0.572c-0.062,0.191-0.194,0.346-0.372,0.437C18.505,9.49,18.386,9.518,18.268,9.518z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'smiley-happy-1',
    },
    name: {
      type: String,
      required: false,
      default: 'SmileyHappy1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>